export default "__VITE_ASSET__DHl0GuLQ__"